import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { PurposeListComponent } from './purpose-list/purpose-list.component'

export const purposeRoutes: Route[] = [
  {
    path: 'purposes',
    component: PurposeListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'purposes/:id/edit',
    redirectTo: 'purposes/:id',
    pathMatch: 'full'
  },
  {
    path: 'purposes/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Purpose',
        nameSingular: 'Purpose',
        namePlural: 'Purposes',
        path: 'purposes',
        slug: 'taxonomies/purposes',
        title: 'Purposes'
      }),
      permission: 'readTaxonomies'
    }
  }
]
